export default "__VITE_ASSET__Q1VGrBIuo9NXgOqY_Ww2pA__"